import React from 'react';
import * as Sentry from '@sentry/react';

import {
  BrowserRouter,
  Route,
  Routes as ReactRouterDomRoutes,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ReactQueryDevtools } from 'react-query/devtools';

import ErrorHandler from './containers/ErrorHandler';
import RangePage from './containers/RangeRoute';
import InSituPage from './containers/InSituRoute';
import ViewPage3D from './containers/3DViewRoute';
import BulletinPage from './containers/BulletinRoute';
import MapPage from './containers/MapRoute';
import { EnvContext } from './context/Env';
import OmiPage from './containers/OmiRoute';
import { Page404 } from './containers/404Route';
import ViewTitle from './components/ViewTitle/ViewTitle';
import HomePage from './components/HomePage/HomePage';
import Header from './components/Header';

import './App.scss';
import BreadCrumb from './components/BreadCrumb';

export default function App() {
  const { env } = EnvContext();

  if (env === null) {
    return (
      <div>
        env.json is invalid. Please create a public/env.json from
        public/env.dist.json
      </div>
    );
  }

  const graphOnly = ['true', ''].includes(
    new URLSearchParams(window.location.search).get('graphOnly'),
  );

  const Routes =
    env.INSTANCE_NAME !== 'local'
      ? Sentry.withSentryReactRouterV6Routing(ReactRouterDomRoutes)
      : ReactRouterDomRoutes;

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ViewTitle />
        <div className={`App${graphOnly ? ' App--isGraphOnly' : ''}`}>
          <Header display={!graphOnly} />
          <div className="App-content">
            {!graphOnly && <BreadCrumb />}
            <Routes>
              <Route path="range" element={<RangePage />} />
              <Route path="in-situ" element={<InSituPage />} />
              <Route path="tz-view" element={<ViewPage3D />} />
              <Route path="bulletin" element={<BulletinPage />}>
                <Route path=":bulletinType" element={<BulletinPage />}>
                  <Route path=":bulletinDate" element={<BulletinPage />}>
                    <Route path="v/:variableId" element={<BulletinPage />} />
                    <Route path="r/:reportId" element={<BulletinPage />} />
                  </Route>
                  <Route path="v/:variableId" element={<BulletinPage />} />
                  <Route path="r/:reportId" element={<BulletinPage />} />
                </Route>
              </Route>
              <Route path="map-view" element={<MapPage />} />
              <Route path="omi" element={<OmiPage />} />
              <Route path="/" element={<HomePage />} />
              <Route path="*" element={<Page404 />} />
            </Routes>
            <ErrorHandler />
          </div>
        </div>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen />
    </QueryClientProvider>
  );
}
